import { render, staticRenderFns } from "./CompanyInfoDisabled.vue?vue&type=template&id=79d139d7&scoped=true"
import script from "./CompanyInfoDisabled.vue?vue&type=script&lang=js"
export * from "./CompanyInfoDisabled.vue?vue&type=script&lang=js"
import style0 from "./CompanyInfoDisabled.vue?vue&type=style&index=0&id=79d139d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d139d7",
  null
  
)

export default component.exports